"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incomeFieldMapping = exports.incomeSchema = void 0;
exports.incomeSchema = {
    fields: {
        institution_name: {
            maxLength: 200,
        },
        institution_street_line1: {
            maxLength: 100,
        },
        institution_street_line2: {
            maxLength: 100,
        },
        institution_street_line3: {
            maxLength: 100,
        },
        institution_city: {
            maxLength: 50,
        },
        institution_state_code: {
            maxLength: 50,
        },
        institution_country_code: {
            maxLength: 2,
        },
        institution_postal_code: {
            maxLength: 20,
        },
        contact_name: {
            maxLength: 50,
        },
        // contact_phone_number: {
        //   minLength: 7,
        //   maxLength: 10,
        // },
        amount: {
            min: 1,
            required: true,
        },
        position_or_title: {
            maxLength: 50,
        },
        description: {
            maxLength: 240,
        },
        date_started: {
            dateFormat: {
                format: 'YYYY-MM-DD',
                message: 'Start Date must be a valid date in YYYY-MM-DD format',
            },
        },
        date_ended: {
            dateFormat: {
                format: 'YYYY-MM-DD',
                message: 'End Date must be a valid date in YYYY-MM-DD format',
            },
        },
    },
    messages: {
        institution_name: {
            maxLength: 'Employer Name must be 200 characters or less',
        },
        institution_street_line1: {
            maxLength: 'Address Line 1 must be 100 characters or less',
        },
        institution_street_line2: {
            maxLength: 'Address Line 2 must be 100 characters or less',
        },
        institution_street_line3: {
            maxLength: 'Address Line 3 must be 100 characters or less',
        },
        institution_city: {
            required: 'City is required',
            maxLength: 'City must be 50 characters or less',
        },
        institution_state_code: {
            maxLength: 'State must be 50 characters or less',
        },
        institution_country_code: {
            maxLength: 'Country must be 2 characters or less',
        },
        institution_postal_code: {
            maxLength: 'Zip Code must be 20 characters or less',
        },
        contact_name: {
            maxLength: 'Supervisor Name must be 50 character or less',
        },
        // contact_phone_number: {
        //   minLength: 'Supervisor Phone Number must be at least 7 characters',
        //   maxLength: 'Supervisor Phone Number must be 10 characters or less',
        // },
        amount: {
            required: 'Gross Income is required',
            min: 'Gross Income must be greater than 0',
        },
        position_or_title: {
            maxLength: 'Job Name must be 50 characters or less',
        },
        description: {
            maxLength: 'Description must be 240 characters or less',
        },
    },
};
// Field mapping between DTO naming and UI naming
exports.incomeFieldMapping = {
    institution_name: 'institution_name',
    institution_street_line1: 'institution_street_line1',
    institution_street_line2: 'institution_street_line2',
    institution_street_line3: 'institution_street_line3',
    institution_city: 'institution_city',
    institution_state_code: 'institution_state_code',
    institution_country_code: 'institution_country_code',
    institution_postal_code: 'institution_postal_code',
    contact_name: 'contact_name',
    contact_phone_number: 'contact_phone_number',
    amount: 'amount',
    position_or_title: 'position_or_title',
    date_started: 'date_started',
    date_ended: 'date_ended',
    description: 'description',
    hour_per_week: 'hour_per_week',
    week_per_year: 'week_per_year',
    hourly_wage: 'hourly_wage',
    frequency: 'frequency',
    social_security_claim_number: 'social_security_claim_number',
    overtime_wage: 'overtime_wage',
    overtime_hours_per_week: 'overtime_hours_per_week',
    bonus_amount: 'bonus_amount',
    frequency_of_bonuses: 'frequency_of_bonuses',
    tips_amount: 'tips_amount',
    frequency_of_tips: 'frequency_of_tips',
    member_receives_overtime_pay: 'member_receives_overtime_pay',
    member_receives_bonuses: 'member_receives_bonuses',
    member_receives_tips: 'member_receives_tips',
};
